import React, { useState } from 'react';
import { useQuery } from '@apollo/client';
import { Box } from '@chakra-ui/react';
import { ADMIN_GET_PROS_WITHIN_REACH_FOR_JOB_AD } from '../../../features/pros-within-reach/constants';
import { 
  AdminProsWithinReachResponse,
  ProsWithinReachQueryVariables,
  Pro,
} from '../../../features/pros-within-reach/types';
import { ProsWithinReachTable } from '../../../features/pros-within-reach/ProsWithinReachTable';

interface ProsWithinReachSectionProps {
  jobAdId: string;
}

const DEFAULT_PAGE_SIZE = 10;

export const ProsWithinReachSection: React.FC<ProsWithinReachSectionProps> = ({
  jobAdId,
}) => {
  const [pros, setPros] = useState<Pro[]>([]);

  const { data, loading, error, fetchMore } = useQuery<{
    adminGetProsWithinReachForEmployerJobAd: AdminProsWithinReachResponse;
  }, ProsWithinReachQueryVariables>(ADMIN_GET_PROS_WITHIN_REACH_FOR_JOB_AD, {
    variables: {
      jobAdId,
      first: DEFAULT_PAGE_SIZE,
    },
    fetchPolicy: 'cache-and-network',
    onCompleted: (data) => {
      if (data?.adminGetProsWithinReachForEmployerJobAd?.edges) {
        setPros(data.adminGetProsWithinReachForEmployerJobAd.edges.map(edge => edge.node));
      }
    },
  });

  const handleLoadMore = () => {
    if (data?.adminGetProsWithinReachForEmployerJobAd.pageInfo.hasNextPage) {
      fetchMore({
        variables: {
          after: data.adminGetProsWithinReachForEmployerJobAd.pageInfo.endCursor,
        },
        updateQuery: (prev, { fetchMoreResult }) => {
          if (!fetchMoreResult?.adminGetProsWithinReachForEmployerJobAd?.edges) {
            return prev;
          }

          const newEdges = fetchMoreResult.adminGetProsWithinReachForEmployerJobAd.edges;
          const newPros = newEdges.map(edge => edge.node);
          
          setPros(prevPros => [...prevPros, ...newPros]);

          return {
            adminGetProsWithinReachForEmployerJobAd: {
              ...fetchMoreResult.adminGetProsWithinReachForEmployerJobAd,
              edges: [
                ...prev.adminGetProsWithinReachForEmployerJobAd.edges,
                ...newEdges,
              ],
            },
          };
        },
      });
    }
  };

  const prosData = data?.adminGetProsWithinReachForEmployerJobAd;
  const totalCount = prosData?.totalCount || 0;
  const pageInfo = prosData?.pageInfo;

  return (
    <Box>
      <ProsWithinReachTable
        pros={pros}
        isLoading={loading}
        error={error}
        pageInfo={pageInfo}
        totalCount={totalCount}
        onLoadMore={handleLoadMore}
      />
    </Box>
  );
};